module.exports = __webpack_public_path__ + "static/media/star2.d88e4a65.png";